var _ = require('ES/lib/lodash');
var dd = require('ES/lib/dd');

module.exports = dd.createClass({
  getInitialState: function () {
    return {left_tabs_height: 100};
  },
  componentWillReceiveProps: function (new_props) {
    var n_tabs_before = _.keys(this.props.tabs).length;
    var n_tabs_after = _.keys(new_props.tabs).length;
    if (n_tabs_after !== n_tabs_before) {
      this.setState({}, this.__handleResize);//call __handleResize after it renders the new_props
    }
  },
  __handleResize: function (e) {
    if (this.refs && this.refs.tab_areas) {
      this.setState({left_tabs_height: this.refs.tab_areas.offsetHeight});
    }
  },
  componentDidMount: function () {
    this.__handleResize();//trigger first one
  },
  render: function () {
    let tabs = this.props.tabs;
    let render_props = this.props.render_props;
    let tab_body = this.props.tab_body;//if you want to explicitly render the body
    let selected_tab = this.props.selected_tab;
    let lefty = !!this.props.lefty;
    let tabs_width = null;
    if (lefty) {
      tabs_width = this.props.tabs_width || 100;
    }
		if (_.isEmpty(tabs)) {
			return dd.div({className: 'TabSet'});
		}
    let first_tab = _.first(_.keys(tabs));
    if (!tabs[selected_tab]) {
      selected_tab = first_tab;
    }
    return dd.div({className: 'TabSet' + (lefty ? ' tabs-left' : '')},
      dd.ul({className: 'nav nav-tabs', style: {width: tabs_width}, ref: 'tab_areas'},
        _.map(tabs, function (tab, id) {
          return dd.li({key: id, className: selected_tab === id ? 'active' : null},
            tab.url || tab.onClick ? dd.a({href: tab.url || '#', onClick: tab.onClick || null}, tab.name) : tab.name
          );
        })
      ),
      lefty ? dd.div({className: 'tab-content', style: {marginLeft: tabs_width, minHeight: this.state.left_tabs_height}},
        dd.div({className: 'tab-pane active'},
          dd.div({style: {float: 'left', width: '100%'}},//hack to fix the layout
            _.isFunction(tabs[selected_tab].render) ? tabs[selected_tab].render(render_props) : tab_body
          ),
          dd.div({className: 'clearfix'})
        )
      ) : null,
      lefty ? null : dd.div({className: 'panel panel-default', style: {borderTopLeftRadius: selected_tab === first_tab ? 0 : null}},
        dd.div({className: 'panel-body'},
          _.isFunction(tabs[selected_tab].render) ? tabs[selected_tab].render(render_props) : tab_body
        )
      ),
      dd.div({className: 'clearfix'})
    );
  }
});



// WEBPACK FOOTER //
// ./src/components/widgets/TabSet.js